// component
import LocationSelect from '@/components/location-select/index.vue';
import ProjectService from '../../publish-project-service.js';
import AssigneeDialog from './assignee-dialog/assignee-dialog.vue';
import Service from '@/service/index.js';
import Bus from '../../../transaction-pro/bus.js';
import { mapGetters, mapMutations } from 'vuex';
import RegExpObj from '@/utils/regExp.js';
import { validateDate } from '@/utils/common.js';

export default {
  components: {
    LocationSelect,
    AssigneeDialog
  },
  props: ['projectInfo'],
  computed: {
    ...mapGetters([
      'userInfo',
      'tradeType',
      'getTenantParams'
    ])
  },
  data () {
    const validateManagementSubjectCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择经营权主体'));
      } else if ((value === '4') && !this.ruleForm.managementSubject) {
        callback(new Error('请输入经营权主体信息!'));
      } else {
        callback();
      }
    };
    const landTypeSubjectCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择土地类别'));
      } else if ((value === '4') && !this.ruleForm.managementSubject) {
        callback(new Error('请输入土地类别信息!'));
      } else {
        callback();
      }
    };
    const validateTransfereeType = (rule, value, callback) => {
      if (this.ruleForm.tradeType === '2') {
        if (!value) {
          callback(new Error('请选择受让方类型'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const validateTransfereeName = (rule, value, callback) => {
      if (this.ruleForm.tradeType === '2') {
        if (!value) {
          callback(new Error('请输入受让人名称'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const validateTransfereeIdCard = (rule, value, callback) => {
      if ((this.ruleForm.tradeType === '2') && (this.ruleForm.transfereeType === '1')) {
        if (!value) {
          callback(new Error('请输入受让人证件号'));
        } else {
          callback();
        }
      } else if (!value) {
        callback(new Error('请输入受让人证件号'));
      } else {
        callback();
      }
    };
    const validateTransfereePhoneNo = (rule, value, callback) => {
      if ((this.ruleForm.tradeType === '2') && (this.ruleForm.transfereeType === '1')) {
        if (!value) {
          callback(new Error('请输入受让人手机号'));
        } else {
          callback();
        }
      } else if (!value) {
        callback(new Error('请输入受让人手机号'));
      } else {
        callback();
      }
    };
    const validateCreditCode = (rule, value, callback) => {
      if ((this.ruleForm.tradeType === '2') && (this.ruleForm.transfereeType !== '1')) {
        if (!value) {
          callback(new Error('请输入统一社会信用代码'));
        } else {
          callback();
        }
      } else if (!value) {
        callback(new Error('请输入统一社会信用代码'));
      } else {
        callback();
      }
    };
    const validateStartTime = (rule, value, callback) => {
      let date = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
      if (!value) {
        callback(new Error('请选择开始日期'));
      } else if (validateDate(date, value) && this.getTenantParams.citytitle !== '抚远市' && this.getTenantParams.citytitle !== '桦川县') {
        callback(new Error('只能选择今天及以后的时间'));
      } else if (validateDate(value, this.ruleForm.endTime)) {
        callback(new Error('开始日期不能晚于结束日期'));
      } else {
        callback();
      }
    };
    const validateEndTime = (rule, value, callback) => {
      let date = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
      if (!value) {
        callback(new Error('请选择结束日期'));
      } else if (validateDate(date, value) && this.getTenantParams.citytitle !== '抚远市' && this.getTenantParams.citytitle !== '桦川县') {
        callback(new Error('只能选择今天及以后的时间'));
      } else if (validateDate(this.ruleForm.startTime, value)) {
        callback(new Error('结束日期不能早于开始日期'));
      } else {
        callback();
      }
    };
    const validateDeliveryPeriod = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入年限'));
      } else if (this.ruleForm.projectType === '6' || (this.ruleForm.projectType === '7' && this.ruleForm.projectSubType === '2')) {
        if (!RegExpObj.cbtime.test(value)) {
          callback(new Error('年限1-30年'));
        } else {
          callback();
        }
      } else {
        if (!RegExpObj.time.test(value)) {
          callback(new Error('年限1-70年'));
        } else {
          callback();
        }
      }
    };
    return {
      length: 0,
      areaCode: '',
      projectTypeArr: [],
      projectSubTypeArr: {}, // 项目分类
      tradeTypeArr: [],
      managementSubjectCodeArr: [],
      managementhouseholdSubjectCodeArr: [],
      landtypeArr: [], // 农户承包地的土地类别
      transfereeTypeArr: [],
      bidGeneralSituationArr: [],
      checked: false,
      dataShow: true,
      repriedDataText: '发包', // 发包期限
      date: [],
      deliveryPeriodMonthList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
      ruleForm: {
        projectType: '1',
        tradeType: '',
        projectSubType: '1', // 项目分类
        // 受让人信息
        // transfereeName: '',
        transfereeIdCard: '',
        transfereePhoneNo: '',
        creditCode: '',
        // transfereeType: '1',
        city: '',
        county: '',
        township: '',
        village: '',
        projectName: '',
        projectNameInit: '',
        address: '',
        managementSubject: '',
        managementSubjectCode: '',
        landCategory: '',
        commonOwnershipDesc: '', // 共有权人
        woodlandUser: '', // 林地使用权人
        forestOwner: '',  // 所有权人
        forestUser: '',   // 使用权人
        transferType: '', // 转让方式
        bidGeneralSituation: [], // 标的概况
        deliveryPeriod: '', // 发包年限
        startTime: '',
        endTime: '',
        transfereeId: '',
        transfereeName: '',
        transfereeType: '',
        deliveryPeriodUnit: '1' // 出租方式
      },
      labelVal: '经营权主体',
      addressText: '坐落位置',
      typeSign: '',
      rules: {
        tradeType: [
          { required: true, message: '请选择交易方式', trigger: 'change' }
        ],
        transfereeId: [
          { required: true, message: '请选择受让人信息', trigger: 'change' }
        ],
        projectType: [
          { required: true, message: '请选择项目类型', trigger: 'change' }
        ],
        projectSubType: [
          { required: true, message: '请选择项目分类', trigger: 'change' }
        ],
        projectNameInit: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        village: [
          { required: true, message: '请选择完整的坐落位置', trigger: 'change' }
        ],
        woodlandUser: [
          { required: true, message: '请输入林地使用权人', trigger: 'change' }
        ],
        forestOwner: [
          { required: true, message: '请输入林木所有权人', trigger: 'blur' }
        ],
        forestUser: [
          { required: true, message: '请输入林木使用权人', trigger: 'change' }
        ],
        bidGeneralSituation: [
          { required: true, message: '请选择标的概况', trigger: 'change' }
        ],
        managementSubjectCode: [
          { required: true, validator: validateManagementSubjectCode, trigger: 'change' }
        ],
        landCategory: [
          { required: true, validator: landTypeSubjectCode, trigger: 'change' }
        ],
        transfereeType: [
          { required: true, validator: validateTransfereeType, trigger: 'change' }
        ],
        transfereeName: [
          { required: true, validator: validateTransfereeName, trigger: 'blur' }
        ],
        transfereeIdCard: [
          { required: true, validator: validateTransfereeIdCard, trigger: 'blur' }
        ],
        transfereePhoneNo: [
          { required: true, validator: validateTransfereePhoneNo, trigger: 'blur' }
        ],
        creditCode: [
          { required: true, validator: validateCreditCode, trigger: 'blur' }
        ],
        commonOwnershipDesc: [
          { required: true, message: '请输共有权人信息', trigger: 'blur' }
        ],
        transferType: [
          { required: true, message: '请选择转让方式', trigger: 'change' }
        ],
        deliveryPeriod: [
          { required: true, validator: validateDeliveryPeriod, trigger: 'change' }
        ],
        startTime: [
          { required: true, validator: validateStartTime, trigger: 'change' }
        ],
        endTime: [
          { required: true, validator: validateEndTime, trigger: 'change' }
        ],
        // startTime: [
        //   { required: true, message: '请选择开始日期', trigger: 'change' }
        // ],
        // endTime: [
        //   { required: true, message: '请选择结束日期', trigger: 'change' }
        // ],
        deliveryPeriodUnit: [
          { required: true, message: '请选择出租方式', trigger: 'change' }
        ]
      },
      address: '',
      projectName: '',
      cityList: [],
      districtList: [],
      townList: [],
      villageList: [],
      isInit: true,
      transferTypeArr: [],
      // 设置只能选择当前日期及之后的日期
      pickerOptions0: {
        disabledDate (time) {
          return time.getTime() < Date.now(); // 如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      // 四荒可选择年限1~50年
      pickerOptions1: {
        disabledDate (time) {
          // 设置可选择的日期为今天之后的一个月内
          let curDate = (new Date()).getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 50 * (365 * 24 * 3600 * 1000);
          let dateRegion = curDate + day;
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion;
        }
      },
      pickerOptions: {
        disabledDate (time) {
          // 设置可选择的日期为今天之后的一个月内
          let curDate = (new Date()).getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 3 * 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion;
          // 设置选择的日期小于当前的日期,小于返回true,日期不可选
          // return time.getTime() < Date.now() - 8.64e7
        }
      },
      dialogVisible: false, // 选择受让人弹出框
      // 受让人信息
      assigneeInfo: {},
      personResForm: null,
      companyForm: null,
      deliveryPeriodUnitList: []
    };
  },
  watch: {
    projectInfo: 'projectInit',
    'ruleForm.projectSubType': function () {
      this.labelChangByType();
      // if ((Number(this.ruleForm.projectType) === 1 || Number(this.ruleForm.projectType) === 3) && Number(this.ruleForm.projectSubType) === 1) {
      //   this.labelVal = '经营权主体';
      // } else if (Number(this.ruleForm.projectType) === 2) {
      //   this.labelVal = '林地使用权人';
      //   if (Number(this.ruleForm.projectSubType) === 3) {
      //     this.labelVal = '转让方类型';
      //   }
      // } else if ((Number(this.ruleForm.projectType) === 6 || Number(this.ruleForm.projectType) === 7) && Number(this.ruleForm.projectSubType) === 1) {
      //   this.labelVal = '所有权主体';
      // } else if (Number(this.ruleForm.projectType) === 4) {
      //   this.labelVal = '使用权主体';
      // }

      // if (Number(this.ruleForm.projectType) === 6 && Number(this.ruleForm.projectSubType) === 1) {
      //   this.repriedDataText = '出租';
      // } else if (Number(this.ruleForm.projectType) === 1 && Number(this.ruleForm.projectSubType) === 2) {
      //   this.repriedDataText = '流转';
      // } else {
      //   this.repriedDataText = '发包';
      // }
      // 传参给other-from
      Bus.$emit('msg', this.ruleForm.projectType, this.ruleForm.projectSubType);
      this.$emit('modulesChoose', this.ruleForm.projectType, this.ruleForm.projectSubType, this.ruleForm.bidGeneralSituation);
    },
    // 当大类发生改变的时候 清空别的类的值
    'ruleForm.projectType': function () {
      this.ruleForm = {
        ...this.ruleForm,
        // tradeType: '',
        projectSubType: '1',
        // 受让人信息
        // transfereeName: '',
        transfereeIdCard: '',
        transfereePhoneNo: '',
        creditCode: '',
        // transfereeType: '1',
        date: [],
        city: '',
        county: '',
        township: '',
        village: '',
        projectName: '',
        projectNameInit: '',
        address: '',
        managementSubject: '',
        managementSubjectCode: '',
        landCategory: '',
        commonOwnershipDesc: '', // 共有权人
        woodlandUser: '', // 林地使用权人
        forestOwner: '',  // 所有权人
        forestUser: '',   // 使用权人
        transferType: '1', // 转让方式
        transfereeId: '', // 受让人ID
        transfereeName: '',
        transfereeType: '',
        deliveryPeriod: '', // 发包年限
        startTime: '',
        endTime: '',
        deliveryPeriodUnit: '1' // 出租方式 年或者月
      };
      this.areaCode = this.getTenantParams.areaCode;
      // 如果说当前大类的typeid和返回的typeid一致 则重新调用projectInfo方法获取basic的val
      if (Number(this.ruleForm.projectType) === Number(this.projectInfo.projectType)) {
        this.projectInit();
      } else {
        // this.getcityInfo();
      }
      // if ((Number(this.ruleForm.projectType) === 1 || Number(this.ruleForm.projectType) === 3) && Number(this.ruleForm.projectSubType) === 1) {
      //   this.labelVal = '经营权主体';
      // } else if (Number(this.ruleForm.projectType) === 2 && Number(this.ruleForm.projectSubType) === 1) {
      //   this.labelVal = '林地使用权人';
      // } else if ((Number(this.ruleForm.projectType) === 6 || Number(this.ruleForm.projectType) === 7) && Number(this.ruleForm.projectSubType) === 1) {
      //   this.labelVal = '所有权主体';
      // } else if (Number(this.ruleForm.projectType) === 4) {
      //   this.labelVal = '使用权主体';
      // }
      // if (Number(this.ruleForm.projectType) === 7 && Number(this.ruleForm.projectSubType) === 1) {
      //   this.addressText = '存放位置';
      // } if (Number(this.ruleForm.projectType) === 6) {
      //   this.addressText = '项目位置';
      // } else {
      //   this.addressText = '坐落位置';
      // }
      // Bus.$emit('msg', this.ruleForm.projectType, this.ruleForm.projectSubType);
      // this.$emit('modulesChoose', this.ruleForm.projectType, this.ruleForm.projectSubType);

      // if (Number(this.ruleForm.projectType) === 6 && Number(this.ruleForm.projectSubType) === 1) {
      //   this.repriedDataText = '出租';
      // } else if (Number(this.ruleForm.projectType) === 1 && Number(this.ruleForm.projectSubType) === 2) {
      //   this.repriedDataText = '流转';
      // } else {
      //   this.repriedDataText = '发包';
      // }

      // 设备不展示发包期限
      // if(Number(this.ruleForm.projectType) === 7 && Number(this.ruleForm.projectSubType) === 1) {
      //   this.dataShow = false;
      // } else {
      //   this.dataShow = true;
      // }
      // 如果是农村集体经济组织用户 就默认选中
      if (this.userInfo.type === 3) {
        this.ruleForm.managementSubjectCode = '1';
      }
      this.labelChangByType();
      
      Bus.$emit('msg', this.ruleForm.projectType, this.ruleForm.projectSubType);
      this.$emit('modulesChoose', this.ruleForm.projectType, this.ruleForm.projectSubType);
    },
    'ruleForm.transferType': function (value) {
      this.SET_TRANSFER_TYPE(value);
      Bus.$emit('msg', this.ruleForm.projectType, this.ruleForm.projectSubType, this.ruleForm.landCategory, value);
    },
    // 交易方式
    'ruleForm.tradeType': function (value) {
      value && this.SET_TRADE_TYPE(value);

      // 公开交易
      if (Number(value) === 1) {
        this.ruleForm = {
          ...this.ruleForm,
          transfereeId: '',
          transfereeName: '',
          transfereeType: ''
        };
        this.companyForm = null;
        this.personResForm = null;
      }
    },
    // 林地使用权人
    'ruleForm.woodlandUser': function (value) {
      this.ruleForm.woodlandUser = value.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, '');
    },
    // 标的名字 只可以输入汉字、数字、字母
    'ruleForm.projectNameInit': function (value) {
      this.ruleForm.projectNameInit = value.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, '');
    },
    // 林木所有权人 只可以输入汉字、数字、字母
    'ruleForm.forestOwner': function (value) {
      this.ruleForm.forestOwner = value.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, '');
    },
    // 林木使用权人 只可以输入汉字、数字、字母
    'ruleForm.forestUser': function (value) {
      this.ruleForm.forestUser = value.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, '');
    },
    'ruleForm.deliveryPeriod': function (value) {
      if (value) {
        this.ruleForm.deliveryPeriod = String(value);
      }
      Bus.$emit('deliveryPeriod', value);
    },
    // 农机设备出租  出租方式
    'ruleForm.deliveryPeriodUnit': function (value, oldValue) {
      if (oldValue) {
        this.ruleForm.deliveryPeriod = '';
      }
    },
    // 标的情况
    'ruleForm.bidGeneralSituation': function (value) {
      Bus.$emit('bidGeneralSituationChange', value);
    }
  },
  created () {
    // 转让方式 默认整体交易
    this.ruleForm.transferType = '1';
    this.ruleForm.tradeType = String(this.tradeType);

    const arr = [
      ['projectTypeArr', 'PROJECT_TYPE'], ['tradeTypeArr', 'TRADE_TYPE'],
      ['managementSubjectCodeArr', 'MANAGEMENT_SUBJECT'], ['transfereeTypeArr', 'TRANSFEREE_TYPE'],
      ['landtypeArr', 'LAND_CATEGORY'], ['managementhouseholdSubjectCodeArr', 'MANAGEMENT_HOUSEHOLD_SUBJECT'],
      ['bidGeneralSituationArr', 'BID_GENERAL_SITUATION'],
      ['transferTypeArr', 'TRANSFER_TYPE'],
      ['deliveryPeriodUnitList', 'DELIVERY_PERIOD_UNIT']
    ];

    // 根据用户类型展示不同 经营权主体
    const managementListByUserType = {
      '1': ['3', '4'],
      '2': ['2', '5', '4'],
      '3': ['1']
    };
    let currentMangementList = managementListByUserType[this.userInfo.type];
    // 如果是农村集体经济组织用户 就默认选中
    if (this.userInfo.type === 3) {
      this.ruleForm.managementSubjectCode = '1';
    }
    arr.forEach((value) => {
      if (!value.length) {
        return;
      };
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
          this.projectSubTypeArr = this.projectTypeArr.find(item => item.code === this.ruleForm.projectType);
          this.tradeTypeArr = this.tradeTypeArr.filter(item => item.code === String(this.tradeType));
          this.managementSubjectCodeArr = this.managementSubjectCodeArr.filter(item => currentMangementList.includes(item.code));
          // this.managementSubjectCodeArr[1] = this.managementSubjectCodeArr.splice(2, 1, this.managementSubjectCodeArr[1])[0];
          // console.log(this.managementSubjectCodeArr);
          // this.managementhouseholdSubjectCodeArr = this.managementhouseholdSubjectCodeArr.filter(item => currentMangementList.includes(item.code));
          // TODO 如果是协议交易 只展示耕地、集体机动地 后续慢慢支持
          // if (Number(this.tradeType) === 2) {
          //   this.projectTypeArr = this.projectTypeArr.filter(item => item.code === '1' || item.code === '2');
          // }
          // 获取资产系统带过来的类型和资产
          if (this.$route.query.assetsId && this.$route.query.accessToken) {
            this.ruleForm.projectType = this.$route.query.projectType;
            this.ruleForm.projectSubType = this.$route.query.projectSubType;
          }
          if (Number(this.tradeType) === 2) {
            this.projectTypeArr = this.projectTypeArr.filter(item => {
              if (item.code === '1' || item.code === '2' || item.code === '4') {
                if (item.code === '2')
                  item.list.length = 2;
                return item;
              }
            });
          }
        }
      });
    });
  },
  mounted () {
    // this.getcityInfo();
  },
  methods: {
    ...mapMutations([
      'SET_TRADE_TYPE',
      'SET_TRANSFER_TYPE'
    ]),
    // 不同类型label不同
    labelChangByType () {
      let type = this.ruleForm.projectType + '-' + this.ruleForm.projectSubType;
      this.typeSign = type;
      if (['7-1', '7-2'].includes(type)) {
        this.addressText = '存放位置';
      } else if (['6-1', '6-2'].includes(type)) {
        this.addressText = '项目位置';
      } else {
        this.addressText = '坐落位置';
      }

      if (['1-1', '1-2', '1-3', '3-1'].includes(type)) {
        this.labelVal = '经营权主体';
      } else if (['2-1', '2-2'].includes(type)) {
        this.labelVal = '林地使用权人';
      } else if (['2-3'].includes(type)) {
        this.labelVal = '转让方类型';
      } else if (['6-1', '6-2', '7-1'].includes(type)) {
        this.labelVal = '所有权主体';
      } else if (Number(this.ruleForm.projectType) === 4) {
        this.labelVal = '使用权主体';
      }

      if (['6-1', '7-2'].includes(type)) {
        this.repriedDataText = '出租';
      } else if (['1-2'].includes(type)) {
        this.repriedDataText = '流转';
      } else if (['8-1'].includes(type)) {
        this.repriedDataText = '期限';
      } else {
        this.repriedDataText = '发包';
      }

      // 农户承包地、水面 默认原用途
      if (['1-2', '3-1'].includes(type)) {
        this.ruleForm.purpose = '原用途';
      } else if (['1-1', '1-3'].includes(type)) {
        // 农户承包地、水面 默认原用途
        this.ruleForm.purpose = '种植业';
      } else {
        this.ruleForm.purpose = '';
      }
    },
    // 农户承包地土地类别更换时
    agreeChange () {
      Bus.$emit('msg', this.ruleForm.projectType, this.ruleForm.projectSubType, this.ruleForm.landCategory, this.ruleForm.transferType);
    },
    clear () {
      this.date = null;
    },
    // 获取basicfrom的val 渲染页面
    projectInit () {
      // 如果是协议交易 并且受让人ID不为空
      if (Number(this.tradeType) === 2 && this.projectInfo.transfereeId) {
        this.getUserInfoById(this.projectInfo.transfereeId);
      }
      Object.keys(this.ruleForm).forEach((key) => {
        if (this.projectInfo && this.projectInfo[key] && ((typeof this.projectInfo[key] === 'string') || (typeof this.projectInfo[key] === 'number'))) {
          this.ruleForm[key] = this.projectInfo && String(this.projectInfo[key]);
          if (key === 'projectName') {
            this.address = this.projectInfo.insectionResForm.address.split(' ')[1] + this.projectInfo.insectionResForm.address.split(' ')[2] + this.projectInfo.insectionResForm.address.split(' ')[3] + this.projectInfo.insectionResForm.address.split(' ')[4];
            var regexp = new RegExp(this.address); // 获取项目名称后面输入框的内容
            var replaceStr = this.projectInfo.projectName.replace(regexp, '');
            this.ruleForm.projectNameInit = replaceStr; // 输入input的value
          }
        }
      });
      if (Number(this.ruleForm.projectType) === Number(this.projectInfo.projectType)) {
        this.isInit = true;
      }
      if (!this.isInit) {
        setTimeout(() => {
          this.areaCode = this.ruleForm.village;
        }, 500);
      } else {
        this.areaCode = this.ruleForm.village;
        this.isInit = false;
      }
      // 综合类 标的情况展示
      if (this.projectInfo && this.projectInfo.assetsInfo && Number(this.projectInfo.projectType) === 8) {
        let list = JSON.parse(this.projectInfo.assetsInfo);
        let _tempArr = [];
        list.map(item => {
          if (item.bidGeneralSituation) {
            _tempArr.push(String(item.bidGeneralSituation));
          }
        });
        this.ruleForm.bidGeneralSituation = _tempArr;
      }
      this.date = [this.ruleForm.startTime, this.ruleForm.endTime];
      this.labelChangByType();
    },
    // 获取项目子类集合
    selectChanged (val) {
      this.projectSubTypeArr = {};
      this.projectTypeArr.forEach(item => {
        if (item.code === val) {
          this.projectSubTypeArr = item;
        }
      });
      this.$emit('form-clear');
    },
    // 获取注册时候位置信息
    getcityInfo () {
      ProjectService.getUserBaseInfo().then(res => {
        if (res && res.code === '0') {
          if (this.areaCode === res.data.county) {
            this.areaCode = res.data.village;
            this.address = res.data.addressDetail.split(' ')[1] + res.data.addressDetail.split(' ')[2] + res.data.addressDetail.split(' ')[3] + res.data.addressDetail.split(' ')[4];
            if (Number(this.ruleForm.projectType) === Number(this.projectInfo.projectType)) {
              if (this.projectInfo.projectName) {
                var regexp = new RegExp(this.address); // 获取项目名称后面输入框的内容
                var replaceStr = this.projectInfo.projectName.replace(regexp, '');
                this.ruleForm.projectNameInit = replaceStr; // 输入input的value
              }
            }
          }
        }
      });
    },
    areaCodeChange (event) {
      const key = event && event.type;
      this.ruleForm[key] = event.areaCode;
      this.areaCode = event.areaCode;

      setTimeout(() => {
        const childRef = this.$refs['locationSelect'] && this.$refs['locationSelect'].$refs;
        // if(childRef) {
        //   this.address = Object.keys(childRef).reduce((current, item) => {
        //     return current += childRef[item].selectedLabel;
        //   }, '');
        // }
        const address = Object.keys(childRef).reduce((current, item) => {
          return current += childRef[item].selectedLabel;
        }, '');
        if (!new RegExp('[0-9]').test(address)) {
          this.address = address;
        }
        this.length = 50 - this.address.trim().length;
      }, 500);
    },
    onChangeDate (event) {
      this.ruleForm.startTime = event && event[0];
      this.ruleForm.endTime = event && event[1];
    },
    // 受让人信息
    changeAssigneeInfo (assigneeInfo, personResForm, companyForm) {
      this.ruleForm = {
        ...this.ruleForm,
        ...assigneeInfo
      };
      this.personResForm = personResForm;
      this.companyForm = companyForm;
      this.dialogVisible = false;
    },
    // 根据用户ID获取用户信息
    getUserInfoById (userId) {
      ProjectService.getUserInfoById(userId).then(({ code, data }) => {
        if (code === '0' && data) {
          this.personResForm = data.personResForm;
          this.companyForm = data.companyForm;
        }
      });
    },
    test () {
      // 重新选择项目位置的基础下
      this.ruleForm.projectName = (this.address + this.ruleForm.projectNameInit).replace(/\s+/g, ''); // 需要传给后台的projectName
      return new Promise((resolve, reject) => {
        this.$refs['basicForm'].validate((valid) => {
          if (valid) {
            console.log(this.ruleForm, 'this.ruleForm');
            resolve(JSON.parse(JSON.stringify(this.ruleForm)));
          } else {
            reject();
          }
        });
      });
    }
  }
};
